import enumeration from "./enumeration";

const TimeUnit = {
  Second: "SECOND",
  Minute: "MINUTE",
  Hour: "HOUR",
  Day: "DAY",
  Week: "WEEK",
  WeekS: "WEEK_SUN",
  Month: "MONTH",
  Quarter: "QUARTER",
  Year: "YEAR",
};

export default enumeration(TimeUnit);
